
const state = {
  projectList: null,
  selectProject: null,
  selectPds: null,
  selectNode: null
}

const mutations = {
  // eslint-disable-next-line no-shadow
  SET_PROJECT_LIST: (state, projectList) => {
    state.projectList = projectList
    console.log(state)
  },
  SET_SELECT_PROJECT: (state, selectProject) => {
    state.selectProject = selectProject
  },
  SET_SELECT_PDS: (state, selectPds) => {
    state.selectPds = selectPds
  },
  SET_SELECT_NODE: (state, selectNode) => {
    state.selectNode = selectNode
  }
}

const actions = {
  projectList({ commit }, val) {
    commit('SET_PROJECT_LIST', val)
  },
  setSelectProject({ commit, dispatch }, val) {
    commit('SET_SELECT_PROJECT', val)
  },
  setSelectPds({ commit }, val) {
    commit('SET_SELECT_PDS', val)
  },
  setSelectNode({ commit }, val) {
    commit('SET_SELECT_NODE', val)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
